"use client";
import { jsx as a } from "react/jsx-runtime";
import s from "clsx";
import { memo as i } from "react";
import { Box as c } from "../base/Base.js";
import '../../assets/HomePage.css';const p = "_grid_wrapper_ekiln_1", d = "_blue_ekiln_1", t = "_darkblue_w_blackout_ekiln_1", u = "_darkblue_ekiln_1", o = "_dark_ekiln_1", k = "_grid_wrapper__left_ekiln_40", g = "_grid_wrapper__right_ekiln_52", m = "_fullscreen_ekiln_84", f = "_landing_fullscreen_ekiln_100", b = "_fullscreen_bg_ekiln_153", w = "_rules_block_ekiln_189", _ = {
  grid_wrapper: p,
  blue: d,
  darkblue_w_blackout: t,
  darkblue: u,
  dark: o,
  grid_wrapper__left: k,
  grid_wrapper__right: g,
  fullscreen: m,
  landing_fullscreen: f,
  fullscreen_bg: b,
  rules_block: w
}, N = i(
  ({ theme: e = "none", className: r, children: l, ...n }) => /* @__PURE__ */ a(
    "div",
    {
      className: s(_.grid_wrapper, _[e], r),
      ...n,
      children: l
    }
  )
);
N.displayName = "GridWrapper";
const y = i(
  ({ className: e, children: r, ...l }) => /* @__PURE__ */ a("div", { className: s(_.grid_wrapper__left, e), ...l, children: r })
);
y.displayName = "GridWrapperLeft";
const G = i(
  ({ className: e, children: r, ...l }) => /* @__PURE__ */ a("div", { className: s(_.grid_wrapper__right, e), ...l, children: r })
);
G.displayName = "GridWrapperRight";
const h = i(
  ({ className: e, children: r, ...l }) => /* @__PURE__ */ a("div", { className: s(_.fullscreen, e), ...l, children: r })
);
h.displayName = "FullScreen";
const v = i(
  ({ theme: e = "none", className: r, children: l, ...n }) => /* @__PURE__ */ a(
    "div",
    {
      className: s(_.landing_fullscreen, _[e], r),
      ...n,
      children: l
    }
  )
);
v.displayName = "LandingFullScreen";
const F = i(
  ({ theme: e = "darkblue", className: r, children: l, ...n }) => /* @__PURE__ */ a(
    "div",
    {
      className: s(_.fullscreen_bg, _[e], r),
      ...n,
      children: l
    }
  )
);
F.displayName = "FullScreenBG";
const L = i(
  ({ theme: e = "none", className: r, children: l, ...n }) => /* @__PURE__ */ a(
    c,
    {
      gap: 40,
      className: s(_.rules_block, _[e], r),
      ...n,
      children: l
    }
  )
);
L.displayName = "RulesBLock";
export {
  h as FullScreen,
  F as FullScreenBG,
  N as GridWrapper,
  y as GridWrapperLeft,
  G as GridWrapperRight,
  v as LandingFullScreen,
  L as RulesBLock
};
